import React, { useEffect, useState, version } from 'react';
import { Typography, Box, Grid, Skeleton } from '@mui/material';
import avatarPlaceholder from '../assets/avatarSample2.jpg';
import CollapsiblePermissionList from './CollapsiblePermission';

const PackageDetailsCard = ({ packageInfo, permission, bucketURLS={} }) => {
  const isDataLoading = packageInfo === undefined || packageInfo === null;
  const parsedInfo = packageInfo?.details?.info ?? {};
  const latestVersion = packageInfo?.review?.component_status === 'underReview' ? packageInfo?.review?.component_version  : parsedInfo?.version;
  const lastPublished = packageInfo?.details?.publishDate;
  // Create a Date object from the string
  const dateObj = new Date(lastPublished);
  // Format the date as YYYY-MM-DD
  const date = dateObj.toISOString().split('T')[0];
  // Format the time as HH:mm:ss
  const time = dateObj.toISOString().split('T')[1].split('.')[0];
  const [downloadUrl, setDownloadUrl] = useState('');

  const owners = permission.filter(item => item.permission === 'owner');
  const collaborators = permission.filter(item => item.permission === 'collaborator');

  useEffect(() => {
    if (bucketURLS.websearch) {
      setDownloadUrl(bucketURLS.websearch)
    }
  }, [bucketURLS]);

  return (
    <Box mt={2}>
      <Typography mb={3} variant='h6'>Package Details</Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3} mb={2}>
          <Typography fontWeight='500'>Latest Version</Typography>
          {!isDataLoading ? (
            <Typography variant='body2' sx={{ color: theme => theme.palette.grey[500], height: '40px', display: 'flex', alignItems: 'center' }} > {latestVersion ? `v${latestVersion}` : 'N/A'}</Typography>
          ) : (
            <Skeleton variant='rectangular' width='60%' height={20} />
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={3} mb={2}>
          <Typography fontWeight='500'>Last Published</Typography>
          {!isDataLoading ? (
            <Typography variant='body2' sx={{ color: theme => theme.palette.grey[500],  height:'40px', display:'flex', alignItems:'center' }}>{date} {time}</Typography>
          ) : (
            <Skeleton variant='rectangular' width='30%' height={20} />
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={3} mb={2}>
          <Typography fontWeight='500'>Owner</Typography>
          <CollapsiblePermissionList
            updatedPermission={owners}
            downloadUrl={downloadUrl}
            avatarPlaceholder={avatarPlaceholder}
          />

        </Grid>

        <Grid item xs={12} sm={6} md={3} mb={2}>
          <Typography fontWeight='500'>Collaborator</Typography>
          <CollapsiblePermissionList
            updatedPermission={collaborators}
            downloadUrl={downloadUrl}
            avatarPlaceholder={avatarPlaceholder}
          />

        </Grid>
      </Grid>


    </Box>
  );
};

export default PackageDetailsCard;
